import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function InfoOutlineIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </StrokeIcon>
  );
}
